import { ProductModel } from "./productModel";
import { ProductRelationTypes } from "../../common/enums";

export class ProductToProductModel {
    public id: number;
    public productId: number;
    public relatedProductId: number;
    public relatedProduct: ProductModel;
    public relationType: ProductRelationTypes;
    public count: number;
}